// buttonコンポーネント

import React from "react";

export default ({ children }) => (
  <div className="buttonComponent">
    <button className="button">{children}</button>
  </div>
);
